export enum SnackBarDuration
{
    DURATION = 3000,
}